// top.js
import React from 'react';
import { Menu, Icon } from 'antd';

import FrameUtils from './FrameUtils';
import Config from '../config/Config';
// import 'antd/dist/antd.css';
const Application = Config.getApplication();
const getCareerUrl = Config.getCareerUrl();
class HeaderMenu extends React.Component {
	constructor(props) {
		super();

		let active = null;

		if (props.titleNode !== undefined) {
			active = props.titleNode[0].name;

			for (var i in props.titleNode) {
				if (props.titleNode[i].exact === true) {
					active = props.titleNode[i].name;
				}
			}
		}

		this.state = {
			active: active,
			titleNode: props.titleNode,
			titleMenuItems: []
		};

		this.handleSelect = this.handleSelect.bind(this);

		// props.onSelect(active);
	}

	handleSelect(activeKey) {

		if (activeKey && activeKey.key && activeKey.key === "careerPlanning") {
			this.RedirectTo();
		} else {
			// if( activeKey.key && activeKey.key === "careerPlanning" || activeKey.key && activeKey.key === "careerPlanning")
			this.setState({ active: activeKey });
			this.props.onSelect(activeKey);
		}

	}

	componentWillMount() {
		let titleMenuItems = FrameUtils.buildMenuItems(this.props.titleNode);

		this.setState({ titleMenuItems: titleMenuItems });
	}



	RedirectTo = () => {
		const accessToken = sessionStorage.getItem('_user_access_');
		if (!accessToken) return window.open(`${getCareerUrl}/login`,'_blank' );
		const encodedToken = btoa(accessToken);
		const signature = btoa(accessToken + Application);
		// window.open(`${getCareerUrl}/home/career-planning?token=${encodedToken}&sig=${signature}`,'_blank' );
		window.open(`${getCareerUrl}/tokenLogin?token=${encodedToken}&sig=${signature}`,'_blank' );
	}

	render() {
		let { active, titleMenuItems } = this.state;

		const { activeKey } = this.props;

		if (activeKey !== undefined) {
			active = activeKey;
		}

		return (
			<div className="sf-system-menu sd-system-menu sg-system-menu" >

				<Menu
					theme="light"
					mode="horizontal"
					defaultSelectedKeys={[activeKey]}
					selectedKeys={[activeKey]}
					items={titleMenuItems}
					onSelect={this.handleSelect}
				/>
			</div>
		);
	}
}


export default HeaderMenu